import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";
import {enumDef} from "@/common/enumDefs";

const defaultState = {
	signUp: {
		referrer: {
			invitationCode: "",
			invitationCodeIsValid: false,
			partnerCustomerId: "",
			redirectUrl: ""
		},
		settings: {
			requiresUserPassword: false
		},
		data: {
			// Start
			language: "",
			invitationCode: "",
			// Master user
			userFirstName: "",
			userLastName: "",
			userPosition: "",
			userPhone: "",
			userEmail: "",
			termsOfServiceCheck: false,
			// Company
			companyCountry: "",
			companyName: "",
			companyLegalStructureId: null,
			companyRegisterCourtId: null,
			companyRegistrationNumber: "",
			companyRegistrationFileId: "",
			companyRegistrationFileName: "",
			companyVatNumber: "",
			bankAccountIban: "",
			bankAccountBic: "",
			bankAccountCurrency: "",
			directDebitCheck: false,
			traderType: enumDef.traderType.Supplier,
			// Kyc
			isMasterUserRepresentative: null,
			hasSolePowerOfRepresentation: null,
			representatives: [],
			beneficialOwners: []
		},
		redirect: {
			partnerName: "",
			redirectUrl: ""
		},
		currentStep: null,
		lastCompletedStep: null,
	},
	seller: {
		preferences: {
			reportFileType: "xlsx"
		}
	},
	investor: {
		preferences: {
			marketSounding: {
				approveCompaniesOnDecision: null,
				rejectCompaniesOnDecision: null
			}
		}
	},
	quickFilters: {}
};

const state = {
	...defaultState
};

const getters = {
	signUpReferrer: state => state.signUp.referrer,
	signUpData: state => state.signUp.data,
	signUpSettings: state => state.signUp.settings,
	signUpRedirect: state => state.signUp.redirect,
	signUpCurrentStep: state => state.signUp.currentStep,
	signUpLastCompletedStep: state => state.signUp.lastCompletedStep,
	sellerPreferences: state => state.seller.preferences,
	quickFilters: state => state.quickFilters,
	investorPreferences: state => state.investor.preferences,
};

const actions = {
	setSignUpReferrer({commit}, payload) {
		commit(types.SET_SIGN_UP_REFERRER, payload);
	},
	setSignUpSettings({commit}, payload) {
		commit(types.SET_SIGN_UP_SETTINGS, payload);
	},
	setSignUpRedirect({commit}, payload) {
		commit(types.SET_SIGN_UP_REDIRECT, payload);
	},
	updateSignUpData({commit}, payload) {
		commit(types.UPDATE_SIGN_UP_DATA, payload);
	},
	setSignUpStepActive({commit}, payload) {
		commit(types.SET_SIGN_UP_STEP_ACTIVE, payload)
	},
	setSignUpStepCompleted({commit}, payload) {
		commit(types.SET_SIGN_UP_STEP_COMPLETED, payload)
	},
	clearSignUp({commit}) {
		commit(types.CLEAR_SIGN_UP);
	},
	setSellerPreferences({commit}, payload) {
		commit(types.SET_SELLER_PREFERENCES, payload)
	},
	setQuickFilter({commit}, payload) {
		commit(types.SET_QUICK_FILTER, payload)
	},
	setInvestorPreferences({commit}, payload) {
		commit(types.SET_INVESTOR_PREFERENCES, payload)
	},
};

const mutations = {
	[types.SET_SIGN_UP_STEP_ACTIVE](state, payload) {
		state.signUp.currentStep = payload;
	},
	[types.SET_SIGN_UP_STEP_COMPLETED](state, payload) {
		state.signUp.lastCompletedStep = Math.max(state.signUp.lastCompletedStep, payload);
	},
	[types.SET_SIGN_UP_REFERRER](state, payload) {
		state.signUp.referrer = payload;

		if (payload.invitationCodeIsValid) {
			state.signUp.data.invitationCode = payload.invitationCode;
			state.signUp.data.partnerCustomerId = payload.partnerCustomerId;
			state.signUp.data.redirectUrl = payload.redirectUrl;
		}
	},
	[types.SET_SIGN_UP_SETTINGS](state, payload) {
		state.signUp.settings = payload;
	},
	[types.SET_SIGN_UP_REDIRECT](state, payload) {
		state.signUp.redirect = payload;
	},
	[types.UPDATE_SIGN_UP_DATA](state, payload) {
		state.signUp.data = {
			...state.signUp.data,
			...payload
		};
	},
	[types.CLEAR_SIGN_UP](state) {
		state.signUp = { ...defaultState.signUp };
	},
	[types.SET_SELLER_PREFERENCES](state, payload) {
		state.seller.preferences = {
			...state.seller.preferences,
			...payload
		};
	},
	[types.SET_QUICK_FILTER](state, payload) {
		state.quickFilters = {
			...state.quickFilters,
			...payload
		};
	},
	[types.SET_INVESTOR_PREFERENCES](state, payload) {
		state.investor.preferences = {
			...state.investor.preferences,
			...payload
		};
	},
	initState(state) {
		resetStoreState(state, defaultState);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
